import { render, staticRenderFns } from "./PlexRecentlyAdded.vue?vue&type=template&id=7a96cc4a&"
import script from "./PlexRecentlyAdded.vue?vue&type=script&lang=js&"
export * from "./PlexRecentlyAdded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports